import { fontSize } from "config/styles/fonts";
import { IAccentColors } from "config/types";

const styles = {
  modalWrap: (isNotVisible: boolean) => ({
    display: isNotVisible ? "none" : "block",
    position: {
      xs: "static",
      md: "fixed",
    },
    pointerEvents: "none",
    "& .MuiBackdrop-root.MuiModal-backdrop": {
      backgroundColor: "inherit",
    },
  }),
  modal: {
    borderRadius: "20px",
    width: {
      xs: "100%",
      md: "440px",
    },
    height: {
      xs: "100%",
      md: "80%",
    },
    minHeight: {
      xs: "100%",
      md: "520px",
    },
    maxHeight: {
      xs: "100%",
      md: "740px",
    },
    position: {
      xs: "static",
      md: "fixed",
    },
    top: {
      md: "30px",
      lg: "80px",
    },
    left: {
      md: "50px",
    },
    p: 0,
    transform: "unset",
    pointerEvents: "auto",
    backgroundColor: "background.default",
    display: "flex",
    flexDirection: "column",
    "& .MuiButtonBase-root.MuiIconButton-root": {
      display: "none",
    },
  },
  contentWrap: (orderId: boolean) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: {
      xs: orderId ? "calc(100dvh - 50px)" : "100%",
      md: "100%",
    },
    position: "relative",
  }),
  burgerIcon: {
    "&.MuiButtonBase-root.MuiIconButton-root": {
      display: "block",
      width: "fit-content",
      position: "absolute",
      right: "16px",
      p: 0,
      top: "8px",
      "&:hover": {
        backgroundColor: "unset",
      },
      "& .MuiSvgIcon-root": {
        width: "30px",
        height: "30px",
      },
    },
  },
  drawer: {
    "&.MuiDrawer-root": {
      zIndex: 1500,
    },
    "& .MuiPaper-root": {
      p: "40px 16px 16px",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
    },
  },
  drawerContent: {
    textTransform: "uppercase",
    lineHeight: 1,
    letterSpacing: 3,
    fontWeight: 700,
    fontSize: fontSize.l,
    textAlign: "right",
    cursor: "pointer",
  },
  header: {
    fontSize: "28px",
    p: {
      xs: "20px 16px 0",
      md: "20px 36px 0",
    },
  },
  innerContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    position: "relative",
    overflowY: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  btnWrap: {
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    backgroundColor: "background.default",
    p: {
      xs: "20px 16px",
      md: "20px 36px",
    },
  },
  btn: (accentColor: IAccentColors) => ({
    width: "100%",
    height: "56px",
    fontSize: fontSize.l,
    textTransform: "capitalize",
    borderRadius: "50px",
    backgroundColor: accentColor.main || "accents.main",
    borderColor: accentColor.main || "accents.main",
    color: "text.primary",
    "&:hover": {
      backgroundColor: accentColor.hover || "accents.hover",
      borderColor: accentColor.hover || "accents.hover",
    },
  }),
  searchModalWrap: {
    "& .MuiBackdrop-root.MuiModal-backdrop": {
      backgroundColor: "inherit",
    },
  },
  searchModal: {
    borderRadius: "10px",
    p: "20px",
    height: {
      xs: "100%",
      md: "400px",
    },
    minHeight: {
      xs: "100%",
      md: "400px",
    },
    maxHeight: {
      xs: "100%",
      md: "400px",
    },
  },
};

export default styles;
